import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box } from "@mui/material";
import { PropsWithChildren } from "react";
import { Typography } from "@platform/design-system";

type Props = PropsWithChildren<{
  title: string;
  description?: string;
}>;

function SuccessMessageWithCheckCircleIcon(props: Props): React.JSX.Element {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <CheckCircleIcon sx={{ fontSize: 48, color: "brandSupporting.medium" }} />
      <Typography variant="header-small" mt={2}>
        <strong>{props.title}</strong>
      </Typography>
      {props.description && <Typography mt={3}>{props.description}</Typography>}
      {props.children}
    </Box>
  );
}

export { SuccessMessageWithCheckCircleIcon };
